/** ערכי סטטוס קנוניים (כפי שנשמרים במערכת) */
export const REPAIR_STATUS_CANONICAL = [
  'התקבל, ממתין לטיפול',
  'ממתין לאישור לקוח',
  'סיום טיפול טכנאי',
  'ממתין למשלוח חזרה',
  'חזר ללקוח',
] as const;

/** תוויות תצוגה — כפי שמוצגות למשתמש (StatusStepper) */
export const REPAIR_STATUS_DISPLAY_LABELS: Record<string, string> = {
  'התקבל, ממתין לטיפול': 'ממתין לטיפול',
  'ממתין לאישור לקוח': 'ממתין לאישור לקוח',
  'סיום טיפול טכנאי': 'סיום טיפול טכנאי',
  'ממתין למשלוח חזרה': 'ממתין למשלוח',
  'חזר ללקוח': 'חזר ללקוח',
  'חזר לחנות': 'חזר ללקוח',
  'בוטל באותו היום': 'בוטל באותו היום',
};

/**
 * תוויות ידידותיות ללקוח — עמוד המעקב הציבורי (RepairTrackPage) ותצוגת "כפי שהלקוח רואה"
 * בתוך ExternalRepairView בלבד. במסכי הצוות הפנימיים (טבלת קריאות, יומן פעילות, בורר סטטוס
 * בטופס) ממשיכים להשתמש ב-REPAIR_STATUS_DISPLAY_LABELS הקצרות/התפעוליות כרגיל.
 */
export const REPAIR_STATUS_CUSTOMER_LABELS: Record<string, string> = {
  'התקבל, ממתין לטיפול': 'התקבל במעבדה, ממתין לטיפול',
  'ממתין לאישור לקוח': 'ממתין לשיחה עם הלקוח',
  'סיום טיפול טכנאי': 'הטכנאי סיים את הטיפול במכשיר',
  'ממתין למשלוח חזרה': 'ממתין למשלוח חזרה',
  'חזר ללקוח': 'חזר ללקוח / לחנות',
  'חזר לחנות': 'חזר ללקוח / לחנות',
  'בוטל באותו היום': 'בוטל באותו היום',
};

/** מיפוי alias ישנים → ערך קנוני */
export function normalizeRepairStatusCanonical(status?: string | null): string {
  const trimmed = String(status || '').trim();
  if (!trimmed) return '';
  if (trimmed === 'התקבל במעבדה' || trimmed === 'ממתין לטיפול') {
    return 'התקבל, ממתין לטיפול';
  }
  if (trimmed === 'חזר לחנות') return 'חזר ללקוח';
  if (trimmed.startsWith('התקבל, ממתין לטיפול')) return 'התקבל, ממתין לטיפול';
  return trimmed;
}

/** תווית תצוגה לסטטוס — רק שמות כפי שמופיעים בתוכנה */
export function formatRepairStatusForDisplay(status?: string | null): string {
  const canonical = normalizeRepairStatusCanonical(status);
  if (!canonical) return '(ריק)';
  return REPAIR_STATUS_DISPLAY_LABELS[canonical] ?? canonical;
}

/** תווית תצוגה לסטטוס — ניסוח ברור/מקצועי ללקוח (עמוד מעקב ציבורי בלבד) */
export function formatRepairStatusForCustomer(status?: string | null): string {
  const canonical = normalizeRepairStatusCanonical(status);
  if (!canonical) return '(ריק)';
  return REPAIR_STATUS_CUSTOMER_LABELS[canonical] ?? REPAIR_STATUS_DISPLAY_LABELS[canonical] ?? canonical;
}

export function repairStatusesEquivalent(
  a?: string | null,
  b?: string | null,
): boolean {
  return normalizeRepairStatusCanonical(a) === normalizeRepairStatusCanonical(b);
}
